module.exports = __webpack_public_path__ + "img/banner.83d6e204.jpg";